// extracted by mini-css-extract-plugin
export var resizer = "_hn-0";